<p-dialog [(visible)]="_visible" [modal]="true" [closable]="true"
          [breakpoints]="{'2000px': '800px', '1900px': '800px', '1700px': '800px',
               '1400px': '700px', '960px': '70vw', '640px': '90vw', '490px':'94vw'}" (onHide)="onHide()">
  <ng-template pTemplate="header">
    <div>
      <h2 class="font-principal my-0 title-blue font-normal font-23">{{ translations?.header }}</h2>
    </div>
  </ng-template>

  <div class="w-full">
    <p-messages [closable]="true" [value]="message"
    [enableService]="false"/>
    <form [formGroup]="formPse" class="grid" (ngSubmit)="sendValues()">
      <div class="col-12 md:col-6">
        <label class="block mb-1" for="naturalezaJuridica">{{ translations?.naturalezaJuridica }}</label>
        <p-dropdown id="naturalezaJuridica"
                    [options]="naturalezasJuridicas" optionLabel="descripcion" optionValue="id"
                    formControlName="naturalezaJuridica"
                    [placeholder]="'components.app-datos-pago-pse.naturaleza-juridica' | translate">
        </p-dropdown>
        <ng-container
          *ngIf="formPse.get('naturalezaJuridica')?.invalid && formPse.get('naturalezaJuridica')?.touched">
          <app-form-group-error-message [control]="formPse.get('naturalezaJuridica')"/>
        </ng-container>
      </div>

      <div class="col-12 md:col-6">
        <label class="block mb-1" for="tipoDocumento">{{ translations?.tipoDocumento }}</label>
        <p-dropdown id="tipoDocumento" [options]="tipoIdentificaciones"
                    optionLabel="abreviatura" optionValue="id"
                    formControlName="tipoDocumento"
                    [placeholder]="translations?.tipoDocumento">
        </p-dropdown>

        <ng-container
          *ngIf="formPse.get('tipoDocumento')?.invalid && formPse.get('tipoDocumento')?.touched">
          <app-form-group-error-message [control]="formPse.get('tipoDocumento')"/>
        </ng-container>

      </div>

      <div class="col-12 md:col-6 ">
        <label class="block mb-1" for="identificacion">{{ translations?.identificacion }}</label>
        <p-inputNumber id="identificacion" type="number"  [useGrouping]="false"
                       class="w-full" formControlName="identificacion"/>
        <ng-container
          *ngIf="formPse.get('identificacion')?.invalid && formPse.get('identificacion')?.touched">
          <app-form-group-error-message [control]="formPse.get('identificacion')"/>
        </ng-container>
      </div>

      <div class="col-12 md:col-6">
        <label class="block mb-1" for="nombreCompleto">{{ translations?.nombreCompleto }}</label>
        <input pInputText id="nombreCompleto" type="text" class="w-full"
               formControlName="nombreCompleto"/>
        <ng-container
          *ngIf="formPse.get('nombreCompleto')?.invalid && formPse.get('nombreCompleto')?.touched">
          <app-form-group-error-message [control]="formPse.get('nombreCompleto')"/>

          <div *ngIf="formPse.get('nombreCompleto')?.errors?.['whitespace'] &&   formPse.get('nombreCompleto')?.touched">
            <small class="p-error">{{ translations.noWhiteSpace }}</small>
          </div>
        </ng-container>
      </div>

      <div class="col-12 md:col-6">
        <label class="block mb-1" for="correoElectronico">{{ translations?.correo }}</label>
        <input id="correoElectronico" type="email" pInputText
               class="w-full" formControlName="correoElectronico"/>
        <ng-container
          *ngIf="formPse.get('correoElectronico')?.invalid && formPse.get('correoElectronico')?.touched">
          <app-form-group-error-message [control]="formPse.get('correoElectronico')"/>
        </ng-container>
      </div>

      <div class="col-12 md:col-6">
        <label class="block mb-1" for="comprobarCorreo">{{ translations?.confirmacionCorreo }}</label>
        <input id="comprobarCorreo" type="email" pInputText autocomplete="false"
               class="w-full" formControlName="comprobarCorreo"/>
        <ng-container
          *ngIf="formPse.get('comprobarCorreo')?.invalid && formPse.get('comprobarCorreo')?.touched">
          <app-form-group-error-message [control]="formPse.get('comprobarCorreo')"/>
          <small class="p-error"  *ngIf="formPse.get('comprobarCorreo')?.errors?.['mustMatchValue']">
            {{ translations.mustMatchValue }}
          </small>
        </ng-container>


      </div>
      <div class="col-12 md:col-6 ">
        <label class="block mb-1" for="telefono">{{ translations?.telefono }}</label>
        <input id="telefono" type="tel" pInputText
                       class="w-full" formControlName="telefono">
        <ng-container
          *ngIf="formPse.get('telefono')?.invalid && formPse.get('telefono')?.touched">
          <app-form-group-error-message [control]="formPse.get('telefono')"/>
          <div *ngIf="formPse.get('telefono')?.errors?.['whitespace'] &&   formPse.get('telefono')?.touched">
            <small class="p-error">{{ translations.noWhiteSpace }}</small>
          </div>
        </ng-container>
      </div>
      <div class="col-12 md:col-6">
        <label class="block mb-1" for="direccion">{{ translations?.direccion }}</label>
        <input pInputText id="direccion" type="text" class="w-full"
               formControlName="direccion"/>
        <ng-container
          *ngIf="formPse.get('direccion')?.invalid && formPse.get('direccion')?.touched">
          <app-form-group-error-message [control]="formPse.get('direccion')"/>
          <div *ngIf="formPse.get('direccion')?.errors?.['whitespace'] &&   formPse.get('direccion')?.touched">
            <small class="p-error">{{ translations.noWhiteSpace }}</small>
          </div>
        </ng-container>
      </div>

      <div class="col-12">
        <label class="block mb-1" for="entidadBancaria">{{ translations?.entidadBancaria }}</label>
        <p-dropdown id="entidadBancaria" [options]="bancos"
                    filter="true" filterBy="descripcion" appendTo="body"
                    optionLabel="descripcion"
                    formControlName="entidadBancaria"
                    [placeholder]="'components.app-datos-pago-pse.entidad-bancaria' | translate ">
        </p-dropdown>
        <ng-container
          *ngIf="formPse.get('entidadBancaria')?.invalid && formPse.get('entidadBancaria')?.touched">
          <app-form-group-error-message [control]="formPse.get('entidadBancaria')"/>
        </ng-container>
      </div>

      <div class="col-12 flex justify-content-center align-items-center mt-2">
        <button pButton type="submit" [disabled]="formPse.invalid">
          <span> {{translations.pagarByPse}}</span>
          <i class="pi pi-lock"></i>
        </button>
      </div>

    </form>
  </div>
</p-dialog>
